import type { MediaWidthSize } from '@/hooks';

export const paymentMobileSize: MediaWidthSize = 'screen1032';
